<script lang="ts" setup>
const {collectionUri} = useI18nCollection();
const {getIndex, getAllButIndex} = usePage();
const servicePages = await queryCollection(collectionUri('services')).all();
const serviceIndex = getIndex(servicePages)!;
const serviceEntries = getAllButIndex(servicePages)!;
const imgUri = computed<string>(() => {
    return serviceIndex?.meta?.imageRef?.replace('/assets', '') || '';
});
</script>

<template>
  <section class="page-container mb-8 text-center">
    <header class="tablet:max-w-[33vw] mx-auto mb-8 tablet:mb-12 desktop:mb-20">
      <h2 class="section-title mb-4">{{ serviceIndex.title }}</h2>
      <ContentRenderer :value="serviceIndex" class="text-dark"/>
    </header>

    <div class="px-4 tablet:flex flex-wrap items-center mb-12 tablet:mb-4">
      <picture class="mb-8 block tablet:w-1/3 tablet:px-3 laptop:px-6 tablet:order-2 tablet:mb-6">
        <media-source
                :dimensions="[
                        { width: 1920 },
                        { width: 1280 },
                        { width: 640 }
                      ]"
                :uri="imgUri"
                as="source"
                format="webp"
                sizes="100vw, (min-width: 768px) 33vw"
        />
        <media-source
                :alt="serviceIndex.title"
                :dimensions="[
                        { width: 1920 },
                        { width: 1280 },
                        { width: 640 }
                      ]"
                :uri="imgUri"
                as="img"
                class-name="w-full h-full object-cover rounded-img aspect-square"
                format="jpg"
                sizes="100vw, (min-width: 768px) 33vw"
        />
      </picture>
      <ArticleHighlight
              v-for="(service, index) in serviceEntries"
              :key="service.path"
              :class="{
                  'tablet:order-1 tablet:pe-6': index === 0,
                  'tablet:order-3 tablet:ps-6': index === 1,
                  'tablet:order-4 tablet:mx-auto tablet:mt-6': index === 2
              }"
              :icon-ref="service?.meta?.icon || ''"
              :title="service.title"
              class="tablet:w-1/3"
      >
        <template #summary>
          <ContentRenderer :value="service" class="tablet:text-sm laptop:text-base mb-12 tablet:mb-0"/>
        </template>
      </ArticleHighlight>
    </div>
    <ButtonCta v-if="serviceIndex?.meta.cta"
               :cta="serviceIndex.meta.cta"
               class="btn-brand mt-3 tablet:mt-8"/>
  </section>
</template>

<style scoped>

</style>